import React from 'react';
import type { EstadoConexionGoogle } from '../../types';
export function IconoGoogle({
  className = 'h-4 w-4'
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false" data-id="element-913" data-mp="f1sd4ujvc9xy">
      <path fill="#4285F4" d="M23.5 12.3c0-.8-.1-1.6-.2-2.3H12v4.5h6.4a5.5 5.5 0 0 1-2.4 3.6v3h3.9c2.3-2.1 3.6-5.2 3.6-8.8Z" data-id="element-914" data-mp="a4a4z6dodyr0" />
      <path fill="#34A853" d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.9-3a7.2 7.2 0 0 1-10.7-3.8H1.3v3.1A12 12 0 0 0 12 24Z" data-id="element-915" data-mp="12t7n99hvzvjr" />
      <path fill="#FBBC05" d="M5.3 14.3a7.2 7.2 0 0 1 0-4.6V6.6H1.3a12 12 0 0 0 0 10.8l4-3.1Z" data-id="element-916" data-mp="xu4hfmu31laq" />
      <path fill="#EA4335" d="M12 4.8c1.8 0 3.4.6 4.6 1.8l3.5-3.5A12 12 0 0 0 1.3 6.6l4 3.1A7.2 7.2 0 0 1 12 4.8Z" data-id="element-917" data-mp="ssx8hkg7eg2h" />
    </svg>;
}
const ESTILO_ESTADO: Record<EstadoConexionGoogle, {
  chip: string;
  etiqueta: string;
}> = {
  conectado: {
    chip: 'bg-exito-50 text-exito-700 ring-exito-100',
    etiqueta: 'Conectado'
  },
  no_conectado: {
    chip: 'bg-gris-100 text-gris-500 ring-gris-200',
    etiqueta: 'No conectado'
  },
  error: {
    chip: 'bg-peligro-50 text-peligro-700 ring-peligro-100',
    etiqueta: 'Error'
  }
};
export function ChipEstadoGoogle({
  estado
}: {
  estado: EstadoConexionGoogle;
}) {
  const estilo = ESTILO_ESTADO[estado];
  return <span className={`inline-flex items-center gap-1.5 rounded px-2 py-0.5 text-2xs font-semibold ring-1 ${estilo.chip}`} data-id="element-918" data-mp="1gegbi5vvw1zn">
      {estilo.etiqueta}
    </span>;
}

/** Marca un evento del calendario interno como espejeado en Google Calendar. */
export function MarcaGoogle({
  titulo
}: {
  titulo: string;
}) {
  return <span title={titulo} className="inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-sm bg-white ring-1 ring-gris-200" data-id="element-919" data-mp="srqbfa33ihho">
      <IconoGoogle className="h-3 w-3" data-id="element-920" data-mp="joz1jepvbts5" />
      <span className="sr-only" data-id="element-921" data-mp="jq0ly9srxsmj">{titulo}</span>
    </span>;
}